// Email storage utility using localStorage (mock backend)
// Replace with actual API calls when backend is ready

const STORAGE_KEY = 'gryp_gear_emails';

export const emailStorage = {
  // Get all stored emails
  getAll() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch (error) {
      console.error('Error reading emails:', error);
      return [];
    }
  },

  // Add a new email
  add(email) {
    try {
      const emails = this.getAll();
      
      // Check for duplicates
      const exists = emails.some(entry => entry.email.toLowerCase() === email.toLowerCase());
      if (exists) {
        return { success: false, message: 'This email is already registered!' };
      }

      // Add new email with timestamp
      const newEntry = {
        email: email.toLowerCase(),
        timestamp: new Date().toISOString(),
        id: Date.now().toString()
      };

      emails.push(newEntry);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(emails));

      return { 
        success: true, 
        message: `You're on the list! ${emails.length} ${emails.length === 1 ? 'person has' : 'people have'} signed up.`,
        count: emails.length
      };
    } catch (error) {
      console.error('Error adding email:', error);
      return { success: false, message: 'Failed to save email. Please try again.' };
    }
  },

  // Remove an email
  remove(id) {
    try {
      const emails = this.getAll();
      const filtered = emails.filter(entry => entry.id !== id);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
      return { success: true };
    } catch (error) {
      console.error('Error removing email:', error);
      return { success: false };
    }
  },

  // Clear all emails
  clear() {
    try {
      localStorage.removeItem(STORAGE_KEY);
      return { success: true };
    } catch (error) {
      console.error('Error clearing emails:', error);
      return { success: false };
    }
  },

  // Get count
  count() {
    return this.getAll().length;
  },

  // Export as CSV
  exportCSV() {
    const emails = this.getAll();
    if (emails.length === 0) return null;

    const headers = ['Email', 'Signup Date', 'Signup Time'];
    const rows = emails.map(entry => {
      const date = new Date(entry.timestamp);
      return [
        entry.email,
        date.toLocaleDateString(),
        date.toLocaleTimeString()
      ];
    });

    const csv = [
      headers.join(','),
      ...rows.map(row => row.join(','))
    ].join('\n');

    return csv;
  }
};